import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createAlbaran } from "../lib/storage";
import { AlbaranForm } from "../components/AlbaranForm";
import { toast } from "sonner";

export default function AlbaranCreate() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const handleSubmit = (form) => {
    setSaving(true);
    try {
      const created = createAlbaran(form);
      toast.success(`Albarán ${created.numero} guardado correctamente`);
      navigate(`/albaran/${created.id}`);
    } catch (e) {
      toast.error("No se pudo guardar el albarán.");
      setSaving(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 py-6 md:py-10">
      <h2 className="text-xl md:text-2xl font-bold tracking-tight text-slate-900 mb-1">Nuevo albarán</h2>
      <p className="text-sm text-slate-500 mb-6">
        El número de albarán (ALB-AAAAMMDD-XXX) y la fecha se generan automáticamente al guardar.
      </p>
      <AlbaranForm mode="create" submitting={saving} onSubmit={handleSubmit} />
    </div>
  );
}
